//created as R&D for AIDA project


import React from "react";
import { Component } from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { ClipLoader } from "react-spinners";
const { Configuration, OpenAIApi } = require('openai');

class Images extends Component {
    constructor() {
        super();
        this.state = {
            heading: "The image will appear here",
            response: "...creating image...",
            size: "large",
            generatedText: "The generated text will appear here in seconds after you click...",
            isLoading: false
        }
    }
    onFormSubmit = (e) => {
        e.preventDefault();
        this.setState({ isLoading: true });

        const formData = new FormData(e.target),
            formDataObj = Object.fromEntries(formData.entries());

        const configuration = new Configuration({
            apiKey: process.env.REACT_APP_OPENAI_API_KEY
        });

        const openai = new OpenAIApi(configuration);

        this.setState({ isLoading: true });
        let size = this.state.size;

        this.setState({ isLoading: true });

        openai.createCompletion({
            model: "text-davinci-003",
            prompt: `Generate  a text for an instagram post in 1st person of a minority digital artist but don't say it. whare are you from, whare do you live? he/she/they are succesful  and politically aware, sometimes activist. Create a name for the artist, a handle for the artist, a  short bio for the artist, a description of the work. Mix them all. make a reference to the artist's style and their last work presented here. Create the hashtags, emojis, their emoji flag ot their origin country for the post. Include fey words in their native laguage. Defy prejudices and expectations, play with stereotypes, create a new narrative with artists not doing nativist work. Selevt 1 to 3 of these: installation, robotics, ai, performance, video, sound, sculpture, painting, drawing, photography, digital `,
            temperature: 0.9,
            max_tokens: 600,
            top_p: 1,
            frequency_penalty: 0,
            presence_penalty: 0,
          }).then((response) => {
            this.setState({
                generatedText: `${response.data.choices[0].text}`,
                isLoading: false,
            }, () => {   openai.createImage({
                prompt:  `${response.data.choices[0].text}`,
                n: 1,
                size: size === "large" ? "1024x1024" : size === "medium" ? "512x512" : "256x256",
            }).then((response) => {
                this.setState({
                    heading: `${formDataObj.ideaName}`,
                    response: `${response.data.data[0].url}`,
                    isLoading: false
              
                }).catch((error) => {
                    console.log(error);
                });
                });
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    handleSizeChange = (e) => {
        this.setState({ size: e.target.value });
    }
render() {
    const sizeOptions = ['large', 'medium', 'small'];
    return (
        <div >
          
            <Container style={ {
            backgroundImage: `url(${this.state.response})`, 
            backgroundRepeat: "repeat", 
            backgroundSize: "cover", 
            backgroundPosition: "center"}}>
               
    <h2 style={{
    color: "#ded5d5",
    fontFamily: "Helvetica",
    fontSize: "40px",
    textShadow: "2px 5px 4px #000000",
    textAlign: "center",
    marginBottom: "30px",
    marginTop: "20px",
    borderRadius: "10px",

   }}> Synthetic Visibility | Minority Artists Generator</h2>
                {/* <img src="molecules.png" alt="logo" style={{ width: "200px", height: "80px", margin: "auto", marginTop: "5px", display: "block" }} /> */}
                <Form onSubmit={this.onFormSubmit}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label style={{
    color: "#454343",
    fontFamily: "Helvetica",
    fontSize: "18px",
    borderRadius: "10px",
    marginTop: "35px",
    textShadow: '1px 2px 2px white, 0 2px 1em white, 0 0 0.2em white',
    backgroundImage: `url(${this.state.response})`, backgroundRepeat: "repeat", backgroundSize: "cover", backgroundPosition: "center"
  }} >
    <p>Synthetic Visibility is a platform that utilizes advanced Artificial Intelligence to generate fictional underepresented minority artists in the digital arts world. The AI creates a text and image that is presented as an Instagram post, complete with hashtags, emojis, and may also include phrases in the synthetic artist's native language. The purpose of Synthetic Visibility is to bring attention to underrepresented minorities in the digital arts world and to inspire creativity and challenge conventional representation. Simply press the "Create Synthetic Minority Artist" button to generate a unique and imaginative output showcasing a synthetic minority artist.</p>
  <br/>
 </Form.Label>
<Form.Group style={{
    display: "flex",
    justifyContent: "center",
    // boxShadow: "2px 5px 4px #000000"
}} controlId="formSize">
    <Form.Control style={{ width: 100, textAlign: "center", paddingTop: "8px",}} as="select" onChange={this.handleSizeChange}>
        {sizeOptions.map((option, index) => (
            <option key={index}>{option}</option>
        ))}
    </Form.Control>
</Form.Group>
 <Button variant="primary" size='lg' type="submit" style={{textShadow: "2px 5px 4px #000000",
                boxShadow:    "2px 5px 4px #000000" ,   marginTop: "5px", backgroundColor: 'grey', borderColor: 'white'   }}>
               Generate Synthetic Minority Artist
                    </Button>
                    
                        <Form.Text className="text-muted">
                        </Form.Text>
                    </Form.Group>
                </Form>
                <br/>
                <br/>
                <Card  >
                <Card.Body>
    {/* <Card.Title><h4> {this.state.heading}</h4></Card.Title> */}
    <hr/>
    <br/>
   
  
    <Card.Text>
    {this.state.isLoading ? <ClipLoader /> :<p>{this.state.generatedText}</p>}
    <Card.Text>

        {/* <p>{this.state.heading} </p> */}

        {this.state.isLoading ? <ClipLoader /> :  <a style={{margin: "auto" , width:'300'}} download="artaifact" rel="noreferrer" href={this.state.response} target="_blank">
        <img style={{width: "90%"}} src={this.state.response} alt=''/>
    </a>}

    </Card.Text>

    </Card.Text>
   
  </Card.Body> 
                </Card>
            </Container>
            </div>
    );
}
}
export default Images;




